import { render, staticRenderFns } from "./statistics-recruitment-recruitments.vue?vue&type=template&id=3ab1bcc4"
import script from "./statistics-recruitment-recruitments.vue?vue&type=script&lang=js"
export * from "./statistics-recruitment-recruitments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports